import { useSignedInDashboardContext } from '../../SignedInDashboardContextProvider';
import { isCareerFeedJob } from '../../hooks/feed-types';
import type { useCareerFeed } from '../../hooks/useCareerFeed';

export const useRecommendationForCareerFeedAiAssistant = (): Pick<
  ReturnType<typeof useCareerFeed>,
  'error' | 'loading' | 'isRefreshLoading' | 'refresh'
> & {
  jobIds: string[];
} => {
  const { careerFeedResult } = useSignedInDashboardContext();

  return {
    // This is a temporary solution to align with the RecsGraphQL to tell GenAI about is the Recs is empty or not
    jobIds:
      careerFeedResult.feedItems?.reduce<string[]>((acc, item) => {
        if (isCareerFeedJob(item)) {
          acc.push(item.id);
        }
        return acc;
      }, []) ?? [],
    ...careerFeedResult,
  };
};
